import { render, staticRenderFns } from "./InsuranceInvoice.vue?vue&type=template&id=0a85e178&"
import script from "./InsuranceInvoice.vue?vue&type=script&lang=js&"
export * from "./InsuranceInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports